import { render, staticRenderFns } from "./TaskBase.vue?vue&type=template&id=adefa14e&"
import script from "./TaskBase.vue?vue&type=script&lang=js&"
export * from "./TaskBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports